import { useTranslations } from "use-intl";
import { toast } from "sonner";
import { CheckIcon } from "@heroicons/react/20/solid";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { acceptQuoteMutation } from "@/app/Quotes/GraphQL/quoteMutations";

type AcceptQuoteFields = {
  purchase_order_number: string;
};

export function AcceptQuoteDialog({
  quoteId,
  purchaseOrderNumber,
}: {
  quoteId: string;
  purchaseOrderNumber?: string | null;
}) {
  const t = useTranslations("quote.acceptDialog");
  const { close, resolve } = useDialogState();
  const { mutateAsync: acceptQuote } = useGqlMutation(acceptQuoteMutation);

  return (
    <BaseDialog title={t("title")} subtitle={t("description")} size="xl">
      <GenericForm<AcceptQuoteFields>
        initialValues={{
          purchase_order_number: purchaseOrderNumber ?? "",
        }}
        onSubmit={async (values) => {
          await acceptQuote({
            id: quoteId,
            purchase_order_number:
              values.purchase_order_number.trim() || undefined,
          });

          toast.success(t("quoteAccepted"));

          await close();
          resolve?.(true);
        }}
      >
        <TextInput
          autoFocus
          name="purchase_order_number"
          label={t("purchaseOrderLabel")}
          description={t("purchaseOrderHelp")}
          optionalLabel
          className="col-span-full"
        />

        <DialogSubmitButton
          text={t("confirm")}
          color="green"
          Icon={CheckIcon}
        />
      </GenericForm>
    </BaseDialog>
  );
}
